class ViewMore {
  constructor(buttonSelector, loadingSelector) {
    $(buttonSelector).click(function () {
      $(this).hide();
      $(loadingSelector).show();
    });
  }
}

export { ViewMore };
